import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
class WholesaleLimitResource extends BaseCamelCasedResource {
    pk() {
        return `${this.customerId}`;
    }
}
WholesaleLimitResource.urlRoot = apiResourceUrl("wholesaleLimit/{vendorId}");
export { WholesaleLimitResource };
//# sourceMappingURL=WholesaleLimitResource.js.map